const TokenCheckerInfo = () => {
    return (
        <div className='container mx-auto mt-8 mb-20 max-w-4xl space-y-4 font-semibold text-[#b3b3b3]'>
            <h1 className='pb-6 text-center text-4xl font-medium text-white'>
                What happens when I report a scam?
            </h1>

            <p>
                Token Checker cannot guarantee we will catch every scam token.
                This is a use case for the general public to file a report. No
                crime should go unpunished. Many scams go unreported which in
                itself encourages scams. If you have been a victim of a token
                scam, have the token placed on Token Checker. The crypto scam
                report page allows public interaction and confirmation.
            </p>

            <p>
                Your report is reviewed by a member of our team. We visit the
                charts and we visit the telegram/discord groups to attempt to
                discover more on the incident. We may engage with the token
                holders. We further investigate what is known or not known about
                the Project team and record all our findings. Once we are
                satisfied that the token is a scam, the token is then published
                on this token checker site to warn new investors. Any
                information discovered will always be available both to victims
                and legal authorities to help in any inquiries. We do not
                believe in centralisation but we believe there should be
                measures to deter scammers in the decentralised zone.
            </p>

            <p>Join our Telegram Token Tracker Bot to:</p>

            <div>
                <ul className='list-inside list-disc'>
                    <li>
                        Receive Scam Alerts when Token Checker publishes new
                        tokens on its platform
                    </li>
                    <li>Receive emergency scam alerts and warnings!</li>
                    <li>
                        Receive warnings of fake Telegram Groups and Telegram
                        Scammers
                    </li>
                    <li>
                        Be notified when a doxxed token is certified by Tally-Ho
                    </li>
                    <li>Receive crypto News Feeds</li>
                </ul>
            </div>

            <p className='space-x-2 text-[#6aa45b]'>
                <span>Tally-Ho</span>
                <span>
                    <strong className='underline transition-colors hover:text-gray-500'>
                        <a href='https://t.me/TokenCheckerTracking'>
                            TokenCheckerBot
                        </a>
                    </strong>
                </span>
            </p>

            <p>
                <span className='text-[#6aa45b]'>
                    Once satisfied that a project is a scam, there are 2
                    conclusions:
                </span>{' '}
                <br />
                1/ Another token was created copying a real token. This is a
                copycat contract and although a scam,it does not represent the
                real token in any way. Be aware of the contract used when buying
                tokens. Tokens marked Copy Cat advises to find the real contract
                address before buying.
                <br />
                2/ The project is a scam and it will be labelled as a scam on
                this site
            </p>

            <p className='underline'>
                If you have been a victim of a scam token.
            </p>

            <p>
                If it is a scam still in progress, the first thing to do is to
                join our Telegram and inform a Mod. The token will be checked
                out and a warning will be announced to our Tally Token
                community. Your instant action could make a difference.
            </p>

            <p>If you are a victim, It’s a simple procedure:</p>
            <p>
                1/ Use the Token Checker Search Bar to check if the token is on
                this site. If the token is already on this site, click the
                confirmation on the scam token for our records. Your interaction
                helps with our records giving indication of impact.
            </p>
            <p>
                2/ Report It If the token is not on Token Checker, report the
                token by simply completing the report form. Your report is
                checked by real people who aim to get as much information about
                the token which may not be helpful at present, but will be kept
                on file in case it could be helpful in future.
            </p>
            <p>
                Use Token Checker as part of your DYOR before buying tokens.
                Tell your fellow investors what to do if they experience a scam.
                Many people have no idea what steps to take when finding
                themselves as victims.
            </p>
            <p>Tally Token Holders</p>
            <div>
                <ul className='list-inside list-disc'>
                    <li>
                        Get Alerts when a token is marked as a scam on Token
                        Checker.
                    </li>
                    <li>
                        Receive notifications when a hot token hits the Tally
                        radar as very popular
                    </li>
                    <li>
                        Be warned first by joining our Telegram. It could make
                        all the difference
                    </li>
                </ul>
            </div>

            <p className='text-[#6aa45b]'>Tally-Ho does Doxxing</p>
            <p>
                Our organisation is a perfect fit for doxxing. Our staff are
                perfectly suited for the job and have systems in place to carry
                out the service. With our upcoming partnership with Reference
                Pass, Tally-Ho is able to speed up the process and follow GDPR
                regulations protecting the individuals we doxx and respecting
                their privacy. Tally-Ho does not handle personal data and our
                service is aimed to protect investors and protect project teams
                equally. To gain a spot on our Doxxed Tokens listing requires a
                token to be established enough to be deemed reasonably safe or
                doxxed by Tally-Ho.
            </p>
            <p>
                Once your token is featured as a Doxxed Token, invite your
                community to upvote it and see your token rise to the top
                encouraging buyers. Direct link to buy your token.
            </p>

            <p className='text-[#6aa45b]'>
                Tally-Ho does not give financial advice or make recommendations
                on investments. Any token displayed as trusted is only
                indication that the Project Owners have taken steps to verify
                themselves as trustworthy people running a project as they
                describe. Always do your own research. Token Checker exists to
                be used as only one part of DYOR. AND REMEMBER:
            </p>
            <p>
                Scams are not successful because they are obvious but because
                they are not.
            </p>

            <p className='float-right ml-auto text-[#6aa45b]'>
                Welcome to Tally-Ho <br />
                Using blockchain technology to serve our users.
            </p>

            <p className='pt-20 text-[#ba5282]'>
                Research is carried out before any token is published on Token
                Checker. We are very diligent and operate a fair system. Wish to
                challenge a report on Token Checker. Apply Here!
            </p>
        </div>
    );
};

export default TokenCheckerInfo;
